import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync } from '@nu-art/thunderstorm-frontend/index';
import './Quai_ButtonLoader.scss';
export class Quai_ButtonLoader extends ComponentSync {
    render() {
        return _jsxs(_Fragment, { children: [this.props.children, _jsx("div", { className: 'quai-button-loader' })] });
    }
}
//# sourceMappingURL=Quai_ButtonLoader.js.map